import { Music, ShoppingBag } from 'lucide-react';
import { TopItemCard } from './TopItemCard';

export function TopContentLists({ topTracks, topMerch }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Top Tracks */}
      <div className="bg-white/5 border border-white/10 rounded-xl p-6">
        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
          <Music className="w-5 h-5 text-purple-400" />
          Top Performing Tracks
        </h3>
        <div className="space-y-3">
          {topTracks.length > 0 ? (
            topTracks.map((track, index) => (
              <TopItemCard
                key={track.id}
                rank={index + 1}
                title={track.title}
                subtitle={track.album}
                value={`${(track.plays || 0).toLocaleString()} plays`}
                imageUrl={track.cover_url}
              />
            ))
          ) : (
            <p className="text-gray-500 text-center py-8">No tracks yet</p>
          )}
        </div>
      </div>

      {/* Top Merch */}
      <div className="bg-white/5 border border-white/10 rounded-xl p-6">
        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
          <ShoppingBag className="w-5 h-5 text-pink-400" />
          Top Selling Merch
        </h3>
        <div className="space-y-3">
          {topMerch && topMerch.length > 0 ? (
            topMerch.map((item, index) => (
              <TopItemCard
                key={item.id}
                rank={index + 1}
                title={item.name}
                subtitle={`$${item.price}`}
                value={`${item.sales_count} sold`}
                imageUrl={item.image_url}
              />
            ))
          ) : (
            <p className="text-gray-500 text-center py-8">No merch sales yet</p>
          )}
        </div>
      </div>
    </div>
  );
}
